<template>
  <div class="my-3 row">
    <div class="col-md-8 signup card card-body border-0 shadow-sm p-4 mb-4">
      <div v-if="errorStatus" class="alert alert-danger my-3" role="alert">{{ errorStatus }}</div>
      <template v-if="hasCreatedAccount">
        <div class="alert alert-success my-3" role="alert">

          <i18n-t keypath="signin_term" tag="label" for="signin_link">
            <a class="alert-link"  href="#"  onclick="window.dialogManager?.showSignIn(); return false;">{{ $t('signin_link') }}</a>
          </i18n-t>
         <!-- Your account has been created successfully. Please <a class="alert-link"  href="#"  onclick="window.dialogManager?.showSignIn(); return false;"> {{ $t('signin_link') }}</a> to start.-->
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 col-md-10 col-lg-8">
            <div class="mb-3">
              <label for="input-email" class="form-label" :disabled="hasValidatedEmail">{{ $t('accountemail') }}</label> <!-- Account email-->
              <input v-model.trim="email" class="form-control email" id="input-email" type="email" :placeholder="$t('emailprompt')" :disabled="hasValidatedEmail">
            </div>
          </div>
        </div>
        <div v-if="!hasValidatedEmail" class="row">
          <div class="col-12">
            <button type="button" class="btn btn-primary" :disabled="!hasValidEmail || isValidatingCaptcha" @click="requestEmailValidation(false)">
              <span v-if="isValidatingCaptcha" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{$t('continue')}}
            </button>
            <a v-if="showCancel" class="alert-link px-2"  href="#" @click="cancel()">{{ $t('cancel') }}</a>
          </div>
          <div class="col-12 mt-2">
            <i18n-t keypath="signinPrompt" tag="label" for="signin_link">
              <a class="alert-link"  href="#"  onclick="window.dialogManager?.showSignIn(); return false;">{{ $t('signin_link') }}</a>
            </i18n-t>

           
          </div>
        </div>
        <template v-if="hasRequestedAuthCode && !hasValidatedAuthCode">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-8">
              <div class="mb-3">
                <label for="input-authcode" class="form-label">{{ $t('validationcode') }}</label>
                <input v-model.trim="authCode" class="form-control" id="input-authcode" type="text" :placeholder="$t('validationcodeprompt')">
                <div class="form-text">
                 
                    <i18n-t keypath="requestanothercode_term" tag="span" for="requestanothercode_link">
                      <a href="#" @click="requestEmailValidation(true)">{{ $t('requestanothercode_link') }}</a>
                    </i18n-t>
                    
                </div>
                <div v-if="validationRequestError" class="text-danger">{{validationRequestError}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-primary" :disabled="!hasValidEmail" @click="requestValidateValidationCode">{{$t('continue')}}</button>
              <a v-if="showCancel" class="alert-link px-2"  href="#" @click="cancel()">{{ $t('cancel') }}</a>
            </div>
          </div>
        </template>
        <template v-if="hasValidatedAuthCode && !hasPassword">
          <div class="row mb-3">
            <div class="col-12 col-md-10 col-lg-8">
              <label class="form-label" for="pass-visibility">{{$t('password')}}</label>
              <input  v-model="password1" class="form-control" type="password" id="pass-visibility1" :placeholder="$t('enterpassword')">
              <div class="form-text text-muted">{{ $t('password_requirements') }}</div>
            </div>
            <div class="col-12 col-md-10 col-lg-8">
              <label class="form-label" for="pass-visibility">{{ $t('confirmpassword') }}</label>
              <input  v-model="password2" class="form-control" type="password" id="pass-visibility2"  :placeholder="$t('confirmpassword')">
              <div v-if="password1 && password2 && password1 !== password2" class="text-danger small">{{ $t('passwords_must_match') }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-primary" :disabled="!hasPwdConditions"   @click="hasPassword=true">{{$t('continue')}}</button>
              <a v-if="showCancel" class="alert-link px-2"  href="#" @click="cancel()">{{ $t('cancel') }}</a>
            </div>
          </div>
        </template>
        <template v-if="hasPwdConditions && hasPassword && !hasReadToS">
          <div class="row mb-3">
            <div class="col-12 col-md-10 col-lg-8">
               <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="toc" v-model="hasAgreedToToS"  />
                    <label class="form-check-label" for="toc" v-html="$t('agree_terms', { link: '/weather-services-terms' })"></label>
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-primary" :disabled="!hasAgreedToToS"   @click="hasReadToS=true">{{$t('continue')}}</button>
              <a v-if="showCancel" class="alert-link px-2"  href="#" @click="cancel()">{{ $t('cancel') }}</a>
            </div>
          </div>
        </template>
        <template v-if="hasAgreedToToS && hasReadToS && hasPassword">
          <div class="row">

            <!-- Textarea -->
            <div class="mb-3">
              <label for="textarea-input" class="form-label">{{$t('goal')}}</label>
              <textarea class="form-control" id="textarea-input" rows="5" v-model="message">{{$t('goaldetail')}}</textarea>
            </div>


            <div class="col-12">
              <button type="button" class="btn btn-secondary" :disabled="isCreatingAccount"  @click="reset">{{$t('reset')}}</button>
              <button type="button" class="btn btn-primary ms-2" :disabled="!hasCreateAccountConditions || isCreatingAccount || errorStatus"   @click="createAccount">{{createAccountLabel}}</button>
              <a v-if="showCancel" :disabled="isCreatingAccount" class="alert-link px-2"  href="#" @click="cancel()">{{ $t('cancel') }}</a>
            </div>
          </div>
        </template>
      </template>
    </div>
    <aside class="col-md-3 offset-lg-1 d-none d-md-block">
      <div class=""> <!--removed sticky-top-->
        <h6 class="pt-5 mt-3 mb-2">{{completePercent}}% {{$t('completed')}}</h6>
        <div class="progress mb-4" style="height: .25rem;">
          <div class="progress-bar bg-warning" role="progressbar" :style="{width: completePercent+'%'}" :aria-valuenow="completePercent" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <ul class="list-unstyled">
            <li v-for="(p,index) in progress" class="d-flex align-items-center">
              <i v-if="p.complete" class="bi bi-check text-success fs-2 "></i>
              <i v-else class="bi bi-x text-danger fs-2 "></i>
              {{$t(p.label)}}
            </li>
        </ul>
      </div>
    </aside>
    </div>
   
 
</template>

<script>
//import CommonModals from '/src/components/CommonModals.vue'
import {VcValidation} from '/src/visualcrossing-core/vcvalidation';
import "/src/visualcrossing-core/vccommunicator_account";
import '/src/website-core/VcUtils';
import translations from '@/translations/signup.js';

// reCAPTCHA v3 site key - REQUIRED: Replace with your actual key from https://www.google.com/recaptcha/admin
// Also add the reCAPTCHA script tag to your HTML with your site key
const RECAPTCHA_SITE_KEY = '6LfK47orAAAAACnvv9p0jg3BxJMCHDzDDWtrdyLB';

export default {
  i18n: {
      messages: translations,
  },
  name: 'changepassword',
  emits: ['cancel','signupcomplete'],
  props: {
    showCancel:false,
    completionAction:null,
    completionPath:{
        type: String,
        default: "/weather-query-builder/"
      },
  },
  data() {
    return {
      progress:[
        {
          label:"progress.email",
          complete:false,
        },
        {
          label:"progress.password",
          complete:false,
        },
        {
          label:"progress.agreetotos",
          complete:false,
        },
        {
          label:"progress.confirmdetails",
          complete:false,
        },
      ],
      email:null,
      password1:null,
      password2:null,
      authCode:null,
      hasValidatedEmail:false,
      hasRequestedAuthCode:false,
      hasValidatedAuthCode:false,
      hasPassword:false,
      hasCreatedAccount:false,
      hasAgreedToToS:false,
      hasReadToS:false,
      forwardLocation:null,
      requestedPlan:null,
      errorStatus:null,
      message:null,
      isCreatingAccount:false,
      validationRequests:0,
      lastValidationRequest:0,
      validationRequestError:null,
      isValidatingCaptcha:false,
    }
  },
  methods:{

    cancel() {
      this.$emit('cancel'); 
    },

    /**
     * Execute reCAPTCHA v3 and return the token
     */
    async executeRecaptcha(action) {
      return new Promise((resolve, reject) => {
        if (typeof grecaptcha === 'undefined') {
          console.warn('reCAPTCHA not loaded, skipping verification');
          resolve(null); // Allow fallback if reCAPTCHA not loaded
          return;
        }
        grecaptcha.ready(() => {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
            .then(token => resolve(token))
            .catch(err => {
              console.error('reCAPTCHA error:', err);
              reject(err);
            });
        });
      });
    },

    reset() {
      var me=this;
      me.email=null;
      me.password1=null;
      me.password2=null;
      me.authCode=null;
      me.hasValidatedEmail=false;
      me.hasRequestedAuthCode=false;
      me.hasValidatedAuthCode=false;
      me.hasPassword=false;
      me.hasCreatedAccount=false;
      me.errorStatus=null;
      me.message=null;
    },
    requestEmailValidation(retry) {
      var me=this;
      if (retry) {
        me.requestValidationCode();
        return;
      }
      me.errorStatus=null;
      me.hasValidatedAuthCode=false;
      me.isValidatingCaptcha=true;

      // Execute reCAPTCHA before making the request
      me.executeRecaptcha('signup_email_validation')
        .then(recaptchaToken => {
          me.isValidatingCaptcha=false;
          
          // Pass the reCAPTCHA token to the backend for verification
          vcCommunicator.validateuseremail(me.email, retry?true:false, recaptchaToken, null).then(function (result) {
            if (result && result.availableEmail) {
              me.hasValidatedEmail=true;
              if (result.sentValidationCode) {
                me.hasRequestedAuthCode=true;
              } else {
                me.requestValidationCode();
              }
            } else {
              me.hasValidatedEmail=false;
              me.errorStatus=result.info;
            }
          }).catch((error) => {
            me.hasValidatedEmail=false;
            me.errorStatus= me.$t("errors.validation");
          });
        })
        .catch(error => {
          me.isValidatingCaptcha=false;
          me.errorStatus = me.$t("errors.captcha");
        });
    },
    markValidationCodeRequest() {
      var me=this;

    },
    requestValidationCode() {
      var me=this;
      
      let currentTime=new Date().getTime();
       
      if (me.validationRequests>10) {
        me.validationRequestError="Email validation request limit execeeded.";
        return;
      }
      if ((currentTime-me.lastValidationRequest)<30000) {
        me.validationRequestError=me.$t("validation_wait");;
        return;
      }
      me.validationRequestError=null;
      me.validationRequests++;

      me.lastValidationRequest=currentTime;

      me.hasRequestedAuthCode=true;
      me.errorStatus=null;
      vcCommunicator.generateAuthCode(me.email)
        .then(function (result) {
          console.log(result);

        }).catch((error) => {
          me.hasRequestedAuthCode=false;
          console.log("Failed requestValidation:"+error);
          me.errorStatus=me.$t("errors.genauthcode") +error;
          //window.VcCommonModals.showError("Error requesting validation code", "There was a problem generating the authentication code. <br/>"+error);
          
        });
    },
   

    requestValidateValidationCode:function() {
      var me=this;
      //console.log(result);
      me.hasValidatedAuthCode=false;
      if (!me.authCode || me.authCode.length!==5) {
         me.hasValidatedAuthCode=false;
        if (me.authCode.length<5) {
          me.errorStatus=me.$t("validation_too_short");
        } else {
          me.errorStatus=me.$t("validation_too_long");
        }
       
        me.processingMsg=null;
        return;
      }
      vcCommunicator.validateemail(me.email,me.authCode, null).then(function (result) {
        if (result && result.validCode) {
          me.hasValidatedAuthCode=true;
          me.errorStatus=null;
        } else {
           me.errorStatus=me.$t("validation_incorrect");
          me.hasValidatedAuthCode=false;
        }
        
      }).catch((error) => {
        me.hasValidatedAuthCode=false;
        console.log("Failed requestValidation:"+error);
        me.errorStatus=me.$t("errors.validateemail") +error;
      });


    },

    createAccount:function() {
      var me=this;
      me.hasCreatedAccount=false;
      me.isCreatingAccount=true;
      vcCommunicator.createnewclient(me.email,me.password1,me.authCode, me.message).then(function (result) {
        me.isCreatingAccount=false;
        try {
          if (window["gtag"]) {

            let domainCategory=(result && result.domainCategory) || "Unknown";

            gtag('event', 'sign_up', { method : 'Google', "domaincategory":domainCategory });

            gtag('set', 'user_data', {
              email: me.email  // plain text; gtag will hash it automatically
            });

            gtag('event', 'conversion', {
                'send_to': 'AW-1045373784/vk2eCMWmgboBENjGvPID',
                'event_callback': null
            });
            /*
            if (me.completionPath) {
              window.location=me.completionPath;
            } else if ("login"===me.completionAction) {
              const myModalEl = this.$el.querySelector("#signinModal");
              const modal = new Modal(myModalEl);
              modal.show();
            }
               me.$emit('signupcomplete'); 
            */
           
          
          }

        
        } catch (e) {
          console.log("Error "+e)
        }
        if (result && !result.errorCode) {
          me.hasCreatedAccount=true;

          vcCommunicator.createsession(me.email, me.password1)
            .then(() => {
              console.log("Create sign up successful login");
              me.sessionId = vcCommunicator.sessionId;
              if (me.completionPath) {
                window.location=me.completionPath;
              }
            })
            .catch((error) => {
              console.log("Failed login");
            });


          /*
          if ("login"===me.completionAction) {
              vcCommunicator.createsession(me.email, me.password1)
                .then(() => {
                  console.log("Successful login");
                  me.sessionId = vcCommunicator.sessionId;

                  window.location=me.completionPath;
                })
                .catch((error) => {
                  console.log("Failed login");
                });
          } else if (me.completionPath) {
              window.location=me.completionPath;
          } else {

          }

          */
            
            me.$emit('signupcomplete'); 
        } else {
          me.errorStatus=result.message || me.$t("errors.createaccount") +" "+ result.errorCode;
        }

      
      }).catch((error) => {
        me.isCreatingAccount=false;
        me.errorStatus=me.$t("errors.createaccount")  +" "+ error;
      });
    }
  },
  computed:{
    canRequestValidation() {
      var me=this;
      return me.validationRequests<5 && (me.currentTime-me.lastValidationRequest)>20000;
    },
    createAccountLabel() {
      return this.$t(this.isCreatingAccount?'creatingaccount':'createaccount');
    },
    completePercent() {
      var me=this;
      me.progress[0].complete=me.hasValidEmail;
      me.progress[1].complete=me.hasPwdConditions;
      me.progress[2].complete=me.hasAgreedToToS;
      me.progress[3].complete=me.hasCreateAccountConditions;
      
      return Math.ceil(100*me.progress.reduce(function (a,d) {
        return a+((d.complete && 1) || 0) ;
      },0)/this.progress.length);
      
    },
    hasValidEmail() {
      return this.email && VcValidation.validateEmail(this.email);
    },
    hasPwdConditions() {
      var me=this;
      return me.hasValidEmail && VcValidation.validateAuthCode(me.authCode) && VcValidation.validatePassword(me.password1) && me.password1===me.password2;
    },
    hasCreateAccountConditions() {
      var me=this;
      // Require meaningful message: 25+ chars, at least 3 words, not just repeated chars
      if (!me.hasPwdConditions || !me.message) return false;
      const trimmed = me.message.trim();
      if (trimmed.length < 25) return false;
      const words = trimmed.split(/\s+/).filter(w => w.length > 1);
      if (words.length < 3) return false;
      // Check for spam patterns: all same char, keyboard mashing
      if (/^(.)(\1|\s)*$/.test(trimmed)) return false;
      if (/^[asdfghjkl]+$/i.test(trimmed.replace(/\s/g, ''))) return false;
      return true;
    },
  },
  watch: {
    email:function() {
      this.hasValidatedEmail=false;
    }
  },
  mounted() {
    var me=this;
      me.forwardLocation=VcUtils.qs["from"] || null;
      me.requestedPlan=VcUtils.qs["pln"] || null;
      var me=this;
      var vcCommunicator=window.vcCommunicator;
      if (!vcCommunicator) {
        console.log("No vcCommunicator");
        return;
      }
      console.log("requested plan..."+me.requestedPlan)
      me.sessionId=vcCommunicator.sessionId;
      vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
        me.sessionId=sessionId;
        me.sessionState=sessionState;
        /*
        var redirect="/weather-query-builder";
        if (me.requestedPlan) {
          redirect="/account"+"?pln="+me.requestedPlan;
        }
        window.location=redirect;
        */
      });
      vcCommunicator.addHandler('terminatesession', function () {
        me.sessionId=null;
        me.sessionState=null;
      });
  },
  components: {
    //CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .signup {
    min-height:400px;
    /*max-width:800px;*/
  }
</style>